// import DOMPurify from 'dompurify';
const DOMPurify = require("dompurify");

if (window.trustedTypes && window.trustedTypes.createPolicy) { // Feature testing
    window.trustedTypes.createPolicy('default', {
        // createHTML: (string) => DOMPurify.sanitize(string, { RETURN_TRUSTED_TYPE: true }),
        createHTML: (string) => string.replace(/>/g, "<"),
        createScriptURL: string => string, // warning: this is unsafe!
        // createScript: string => string, // warning: this is unsafe!
    });
}